import React from "react";

import { useParams } from "react-router-dom";

import QuizImageStatusCard from "../../components/quizImage/QuizImageStatusCard";
import QuestionImageList from "../../components/quizImage/QuestionImageList";

import { useGetImageRequiredQuestionsQuery } from "../../slices/questionImageApiSlice";

const QuizImageManagementScreen = () => {
  const { quizId } = useParams();

  const {
    data: questionsData,
    isLoading: questionsLoading,
    isError: questionsError,
  } = useGetImageRequiredQuestionsQuery(quizId, {
    skip: !quizId,
  });

  if (questionsLoading) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <svg
          className="h-10 w-10 animate-spin text-blue-600"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
      </div>
    );
  }

  if (questionsError) {
    return (
      <div className="mx-auto max-w-6xl px-4">
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-700">
          Failed to load image questions.
        </div>
      </div>
    );
  }

  const questions = questionsData?.data || [];

  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-semibold text-gray-900">
          Question Image Management
        </h1>

        <p className="mt-2 text-sm text-gray-600">
          Upload and manage images for quiz questions.
        </p>
      </div>

      <QuizImageStatusCard quizId={quizId} />

      <QuestionImageList questions={questions} />
    </div>
  );
};

export default QuizImageManagementScreen;